// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { requestRmaReceiveLabelStyles } from "@guestsupply/App/Widgets/RequestRma/RequestRmaReceiveLabel";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Edit from "@insite/mobius/Icons/Edit";
import { RadioStyle } from "@insite/mobius/Radio";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

requestRmaReceiveLabelStyles.receiveLabelGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        margin-top: 20px;
    `,
};
requestRmaReceiveLabelStyles.receiveLabelsLabel = {
    ...xOrderInformationStyles.address?.heading,
};
requestRmaReceiveLabelStyles.receiveLabelsRadioGroup = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: inline-block;
                    width: 100%;
                    & > ${RadioStyle} {
                        display: block;
                        margin-top: 10px;
                    }
                `,
                css`
                    display: inline-block;
                    width: 100%;
                    & > ${RadioStyle} {
                        display: block;
                        margin-top: 10px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
                css`
                    display: inline-block;
                    & > ${RadioStyle} {
                        display: inline-block;
                        margin-right: 20px;
                    }
                `,
            ])}
    `,
};
requestRmaReceiveLabelStyles.requestReplacementCheckbox = {
    css: css`
        margin-top: 15px;
    `,
};
requestRmaReceiveLabelStyles.emailFieldWrapper = {
    css: css`
        min-width: 250px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};